import React from 'react';

import styled from 'styled-components';

import { DiskButton } from 'apps/auth/components/common/DiskButton/DiskButton';
import { Text } from 'apps/auth/components/common/Text/Text';
import media from 'apps/auth/theme/media';

interface SeparatorLineProps {
    marginTop?: string;
    marginBottom?: string;
    marginTopDesktop?: string;
    marginBottomDesktop?: string;
    isSubheader?: boolean;
}

const shouldForwardSeparatorLineProp = (prop: string) =>
    !['marginTop', 'marginBottom', 'marginTopDesktop', 'marginBottomDesktop', 'isSubheader'].includes(prop);

const SeparatorLine = styled.div.withConfig({ shouldForwardProp: shouldForwardSeparatorLineProp })<SeparatorLineProps>`
    display: ${(props) => (props.isSubheader ? 'flex' : null)};
    background-color: ${(props) => (props.isSubheader ? props.theme.grey_8_lc : props.theme.grey_28_tr)};
    height: ${(props) => (props.isSubheader ? null : '1px')};
    margin-left: -24px;
    margin-right: -24px;
    margin-top: ${(props) => (props.marginTop ? props.marginTop : '32px')};
    margin-bottom: ${(props) => (props.marginBottom ? props.marginBottom : '32px')};
    padding: ${(props) => (props.isSubheader ? '16px 24px' : null)};
    justify-content: ${(props) => (props.isSubheader ? 'space-between' : null)};
    align-items: ${(props) => (props.isSubheader ? 'center' : null)};

    ${media.desktop1920} {
        margin-left: ${(props) => (props.isSubheader ? '-24px' : '-32px')};
        margin-right: ${(props) => (props.isSubheader ? '-24px' : '-32px')};
        margin-top: ${(props) => (props.marginTopDesktop ? props.marginTopDesktop : '48px')};
        margin-bottom: ${(props) => (props.marginBottomDesktop ? props.marginBottomDesktop : '48px')};
    }

    & > span {
        flex: 1;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
    }
`;

const RightBlock = styled.span`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-left: 8px;

    & > span {
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
    }
`;

interface SeparatorProps extends SeparatorLineProps {
    leftText?: string;
    rightText?: string;
    hasRightTextInfo?: boolean;
    onClick?: React.MouseEventHandler<HTMLButtonElement>;
}

export const Separator: React.FC<SeparatorProps> = ({
    marginTop,
    marginBottom,
    marginTopDesktop,
    marginBottomDesktop,
    isSubheader,
    leftText,
    rightText,
    hasRightTextInfo,
    onClick,
}) => {
    return (
        <SeparatorLine
            marginTop={marginTop}
            marginBottom={marginBottom}
            marginTopDesktop={marginTopDesktop}
            marginBottomDesktop={marginBottomDesktop}
            isSubheader={isSubheader}
        >
            {isSubheader ? (
                <>
                    <Text size="subheader" color="secondary">
                        {leftText}
                    </Text>
                    {rightText && (
                        <RightBlock>
                            <Text size="subheader" color="secondary" textAlign="right">
                                {rightText}
                            </Text>
                            {hasRightTextInfo && (
                                <DiskButton
                                    type="button"
                                    variant="tertiary_light"
                                    size="small"
                                    iconName="info-rounded"
                                    iconColor="secondary"
                                    raised={false}
                                    onClick={onClick}
                                />
                            )}
                        </RightBlock>
                    )}
                </>
            ) : null}
        </SeparatorLine>
    );
};
